module.exports = __webpack_public_path__ + "static/media/policy-1.3bb594b6.png";